{
  "tasks": {
    "title": "Tasks",
    "description": "Tasks a colleague or an app has handed to you",
    "columns": {
      "title": "Task",
      "createdBy": "Created by",
      "dueAt": "Due",
      "source": "Reference"
    },
    "markDone": "Done",
    "openSource": "Open",
    "empty": "No open tasks",
    "search": "Search tasks...",
    "completed": "“{{title}}” done",
    "completeFailed": "The task could not be completed",
    "review": "View"
  },
  "myTasks": {
    "title": "My Tasks",
    "description": "Everything currently waiting for your action",
    "openProcessesTitle": "Open Processes",
    "openProcessesDescription": "Processes you're responsible for that you haven't started recording yet",
    "inProgressRecordingsTitle": "In Progress Recordings",
    "inProgressRecordingsDescription": "Process steps you started describing but haven't completed yet",
    "assignmentsTitle": "My Assignments",
    "assignmentsDescription": "Process steps assigned to you that are waiting for your action.",
    "pendingSurveysTitle": "Pending Surveys",
    "pendingSurveysDescription": "Provide feedback on your recorded process steps",
    "pendingReviewsTitle": "Pending Reviews",
    "pendingReviewsDescription": "Approve or reject systems and functions that were suggested during recording",
    "noPendingReviews": "No pending reviews",
    "searchPendingReviews": "Search reviews...",
    "review": "Review",
    "kind": "Kind",
    "name": "Name",
    "submittedBy": "Submitted by",
    "source": "Suggested in",
    "submittedAt": "Submitted",
    "openSourceRecording": "Open recording",
    "unnamedProcess": "Unnamed process",
    "process": "Process",
    "department": "Department",
    "processOwner": "Process Owner",
    "processStep": "Process Step",
    "previousProcessStep": "Previous Process Step",
    "processStart": "Process Start",
    "processStepGeneric": "Process Step",
    "newStep": "New process step assignment",
    "unclearResolution": "Unclear next assignee",
    "decisionStep": "Decision Step",
    "dueDate": "Due Date",
    "startedDate": "Started Date",
    "assignedBy": "Assigned By",
    "startRecording": "Start Recording",
    "completeSurvey": "Complete Survey",
    "noOpenProcesses": "No open processes found",
    "noInProgressRecordings": "No in-progress recordings found",
    "noAssignments": "No pending assignments found",
    "noPendingSurveys": "No pending surveys found",
    "searchInProgressRecordings": "Search recordings...",
    "searchSurveys": "Search surveys...",
    "searchOpenProcesses": "Search processes...",
    "searchAssignments": "Search assignments...",
    "noTasksTitle": "All tasks done!",
    "noTasksDescription": "Nothing is waiting for you right now. New tasks show up here automatically.",
    "variantAnswerSaved": "Answer saved",
    "variantAnswerFailed": "Failed to save your answer",
    "surveySubmitFailed": "Failed to submit survey"
  },
  "assignmentReview": {
    "previousStep": "Previous Step",
    "outputLabel": "Output:",
    "stepInfoUnavailable": "Step information not available",
    "accept": "Assign Me",
    "deny": "Don't Assign Me",
    "successAcceptedTitle": "You have been assigned successfully!",
    "successAcceptedDesc": "You can now start describing your process step.",
    "successRejectedTitle": "Thank you for your feedback!",
    "successRejectedDesc": "The process step will be reassigned.",
    "finish": "Finish",
    "mergeSectionTitle": "This step may already exist in this process",
    "mergeSectionDescription": "Instead of recording from scratch, you can merge this assignment into an existing step.",
    "mergeInto": "Merge into this step",
    "mergeConfirmTitle": "Merge assignment?",
    "mergeConfirmDescription": "This assignment will be linked to \"{{stepName}}\" instead of creating a new recording. This action cannot be undone.",
    "mergeConfirm": "Merge",
    "mergeCancel": "Cancel",
    "mergeError": "Failed to merge assignment",
    "unnamedStep": "Unnamed step",
    "selectMergeCandidate": "Select a step to merge into…",
    "searchMergeCandidates": "Search steps…",
    "noMergeCandidates": "No matching steps found.",
    "systemAssigneeHintTitle": "This step is performed by a system",
    "systemAssigneeHintDescription": "You are listed as the system owner for this system. Describe what the system does — not what you do yourself.",
    "externalContactAssigneeHintTitle": "This step is performed by an external contact",
    "externalContactAssigneeHintDescription": "You record this step on their behalf. Describe what the external contact does — not what you do yourself."
  },
  "reassignContext": {
    "title": "Assign the next assignee",
    "descriptionPending": "Pick a new assignee — or mark the step as unclear if it's not yet known who takes it on.",
    "descriptionPendingUnclear": "Resolve the unclear assignment: choose who takes over the next step.",
    "descriptionRecording": "Pick a new assignee — or mark the step as unclear if it's not yet known who takes it on.",
    "unclearAlertTitle": "Assignment marked as unclear",
    "unclearAlertDescription": "This assignment was given to you as the process owner because it wasn't specified during recording who takes over the next step. Review the step details and assign a next assignee.",
    "markedUnclearBy": "Marked as unclear by",
    "stepDetails": "Step details",
    "currentStep": "Step being reassigned",
    "assignToHeading": "Assign to",
    "chooseAssignee": "Select a person, function or system",
    "markedUnclear": "Marked as unclear",
    "confirm": "Continue"
  },
  "celebration": {
    "banner": {
      "title": "Thanks for your effort!",
      "description_one": "You just completed 1 task.",
      "description_other": "You just completed {{count}} tasks.",
      "doneCount": "{{count}} done",
      "openCount": "{{count}} open"
    },
    "recordingStarted": {
      "title": "Recording started!",
      "description": "“{{process}}” is under way: the first people are invited and are now describing their steps."
    },
    "survey": {
      "title": "Thanks for your feedback!",
      "remaining_one": "1 survey left – it takes about a minute.",
      "remaining_other": "{{count}} surveys left – each takes about a minute.",
      "allDone": "All surveys done. Now your team knows how the work really runs.",
      "nextSurvey": "Next survey"
    },
    "step": {
      "title": "Done!",
      "description": "Your step is now part of “{{process}}”. Thanks for sharing what you know!",
      "startSurvey": "Start short survey (about 1 min)"
    },
    "toTasks": "Go to my tasks",
    "later": "Later"
  },
  "approvals": {
    "status": {
      "approved": "Approved",
      "executed": "Done",
      "rejected": "Rejected",
      "overridden": "Continued without approval",
      "withdrawn": "Withdrawn",
      "pending": "Open"
    },
    "card": {
      "progress": "{{count}} of {{total}} approved",
      "requestedBy": "Requested by {{name}} on {{date}}",
      "due": "due {{date}}",
      "reviewers": "Reviewers",
      "reviewersNeeded_one": "{{count}} of {{total}} must approve",
      "reviewersNeeded_other": "{{count}} of {{total}} must approve",
      "verdict": {
        "open": "still open",
        "approved": "approved ({{date}})",
        "rejected": "rejected ({{date}})"
      },
      "overriddenBy": "{{name}} continued without approval ({{date}})",
      "rejectReason": "Reason for rejection",
      "rejectReasonPlaceholder": "Why? The requester reads the reason.",
      "approve": "Approve",
      "reject": "Reject",
      "confirmReject": "Reject with reason",
      "withdraw": "Withdraw",
      "openRecord": "Open",
      "override": "Continue without approval"
    },
    "override": {
      "title": "Continue without approval?",
      "warning": "This bypasses the four-eyes principle. The reviewers are informed and the request is logged as skipped.",
      "confirm": "Continue without approval",
      "reason": "Reason",
      "reasonPlaceholder": "Why can this not wait?"
    },
    "recipients": {
      "intro_one": "This person gets a task:",
      "intro_other": "These {{count}} people get a task:",
      "due": "Due on {{date}}.",
      "required": "{{count}} of {{total}} must approve."
    },
    "dialogTitle": "Approval",
    "actionFailed": "The action failed",
    "toast": {
      "approved": "Approved",
      "rejected": "Rejected",
      "overridden": "Continued without approval",
      "withdrawn": "Withdrawn"
    },
    "title": "Approvals",
    "descriptionAll": "All approvals of the workspace",
    "descriptionMine": "Approvals you requested or review",
    "empty": "No approvals",
    "search": "Search approvals",
    "columns": {
      "label": "What",
      "status": "Status",
      "requestedBy": "Requested by",
      "reviewers": "Reviewers",
      "requestedAt": "Requested on"
    }
  }
}
